import type HierarchyNode from '~/client/src/shared/models/HierarchyNode'

export function visibleHierarchyNodes(
  nodes: readonly HierarchyNode[],
  searchKey: string,
): HierarchyNode[] {
  const search = searchKey?.toLocaleLowerCase()

  return nodes.filter(
    node =>
      !node.isHidden &&
      !(search && node.name && !node.name.toLocaleLowerCase().includes(search)),
  )
}
